module.exports = __webpack_public_path__ + "img/apple.4e5c624e.png";